import { RefObject, useEffect } from 'react';

/** Nearest ancestor that actually scrolls. */
const scrollingAncestor = (element: HTMLElement | null) => {
  let node = element?.parentElement ?? null;

  while (node) {
    const { overflowY } = window.getComputedStyle(node);

    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }

    node = node.parentElement;
  }

  return null;
};

/**
 * Returns the view to the top whenever `key` changes.
 *
 * The modal swaps views inside one scrolling region it keeps mounted, so the
 * previous view's scroll position would otherwise carry over.
 */
export const useScrollToTopOnChange = (
  ref: RefObject<HTMLElement>,
  key: unknown,
) => {
  useEffect(() => {
    scrollingAncestor(ref.current)?.scrollTo({ top: 0 });
  }, [ref, key]);
};
